//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { Loading } from "element-ui";
export default {
  data() {
    return {
      photo: {
        sz: [], //舌照
        mz: [], //面照
        qt: [] //其他
      },
      deletePhoto: [],
      message: { isup: false }
    };
  },
  created() {
    this.$isLogin(window.location.search.substr(1), this.query);
    document.title = '舌照面照'
    // this.$store.state.indexThis = this;
    // var _this = this;
    // this.$store.state.websocketdosome.onMessage[3] = function() {
    //   _this.query();
    // };
    // this.$store.state.websocketdosome.onMessage[8] = function() {
    //   _this.query();
    // };
  },
  methods: {
    query() {
      var _this = this;
      this.message = this.$store.state.AllOfValue.imuploadFacePic;
      this.$doRequest(
        "/api/Inquiry/orderDetails",
        {
          orderID: this.message.orderid,
          isAccordingexchanges: 1
        },
        res => {
          for (var i = 0; i < res.accordingTtongue.length; i++) {
            _this.photo.sz.push({
              url: res.accordingTtongue[i],
              fileurl: res.accordingTtongue[i]
            });
          }
          for (var i = 0; i < res.surfaceAccording.length; i++) {
            _this.photo.mz.push({
              url: res.surfaceAccording[i],
              fileurl: res.surfaceAccording[i]
            });
          }
          for (var i = 0; i < res.otherdetails.length; i++) {
            _this.photo.qt.push({
              url: res.otherdetails[i],
              fileurl: res.otherdetails[i]
            });
          }
        }
      );
    },
    chooseImg(e) {
      if(e.target.files[0].type.indexOf('video') > -1){
        this.$toastMsg('舌照面照仅支持图片上传');
        return false;
      }
      var _this = this;
      var type = e.srcElement.attributes.uptype.nodeValue;
      var formData = new FormData();
      formData.append("file", e.target.files[0]);
      var _this = this;
      let loadingInstance = Loading.service({
        text: "正在上传",
        background: "rgba(0, 0, 0, 0.7)"
      });
      this.$doRequest(
        {
          url: "/api/FastDfs/uploadLocal",
          catchs: function(err) {
            _this.$nextTick(() => {
              // 以服务的方式调用的 Loading 需要异步关闭
              loadingInstance.close();
            });
            _this.$toastMsg('上传失败')
          }
        },
        formData,
        res => {
          _this.$nextTick(() => {
            // 以服务的方式调用的 Loading 需要异步关闭
            loadingInstance.close();
          });
          _this.photo[type].push({
            url: res[0].fileUrl,
            fileurl: "/api/StaticFile/fastdfsLocalURL/" + res[0].fileUrl
          });
        },
        null,
        null,
        true
      );
    },
    del(e) {
      var _this = this;
      var type = e.srcElement.attributes.uptype.nodeValue;
      var durl = e.srcElement.attributes.durl.nodeValue;
      var newphoto = [];
      this.deletePhoto.push(durl);
      for (var i = 0; i < _this.photo[type].length; i++) {
        if (_this.photo[type][i].url != durl) {
          newphoto.push(_this.photo[type][i]);
        }
      }
      _this.photo[type] = newphoto;
    },
    success() {
      var _this = this;
      var accordingTtongue = [],
        surfaceAccording = [],
        otherdetails = [];
      for (var i = 0; i < _this.photo.sz.length; i++) {
        accordingTtongue.push(_this.photo.sz[i].url);
      }
      for (var i = 0; i < _this.photo.mz.length; i++) {
        surfaceAccording.push(_this.photo.mz[i].url);
      }
      for (var i = 0; i < _this.photo.qt.length; i++) {
        otherdetails.push(_this.photo.qt[i].url);
      }
      if (accordingTtongue.length < 1) {
        _this.$toastMsg("请完善舌照");
        return false;
      }
      if (surfaceAccording.length < 1) {
        _this.$toastMsg("请完善面照");
        return false;
      }
      this.$doRequest(
        "/api/Inquiry/tongueFace",
        {
          orderid: this.message.orderid,
          doctorid: this.message.doctorid,
          parientid: this.$store.state.userInfo.id,
          deletePhoto: this.deletePhoto,
          accordingTtongue: accordingTtongue,
          surfaceAccording: surfaceAccording,
          otherdetails: otherdetails
        },
        res => {
          _this.$toastMsg("提交成功");
          var ext = {
            'businessType': 'facePicFinish',
            'orderid': _this.message.orderid
          }
          _this.$sendPrivateText(_this,_this.message.doctorid,'我已上传舌照面照',function(msg){
            _this.$router.go(-1);
            var data = {
              fromid: _this.$store.state.userInfo.id,
              toid: _this.messages.doctorId,
              msgtype: '3',
              val: '患者已上传舌照面照',
              fromType: '2',
              fromName: _this.$store.state.userInfo.patientnickname,
              orderid: _this.message.orderid
            }
            _this.$doRequest('/api/ImUtil/signIm',data,function(res){
            })
          },ext)
        }
      );
    }
  }
};



// WEBPACK FOOTER //
// ./src/views/upload/four/four.vue